import { Divider, Menu, MenuItem } from "@material-ui/core";
import { Css } from "src/Css";
import { openUrl } from "src/utils";

export interface DocumentMenuProps {
  anchorEl: HTMLElement;
  disableView?: boolean;
  closeMenu: Function;
  isMenuOpen: boolean;
  onModalOpen: Function;
  url: string;
}

/**
 * Displays a menu for the DocumentBlock component with two menu items: View and Download
 */
export function DocumentMenu(props: DocumentMenuProps) {
  const { anchorEl, disableView = false, closeMenu, isMenuOpen, onModalOpen, url } = props;
  function handleViewClick() {
    onModalOpen(document);
    closeMenu();
  }

  function handleDownloadClick() {
    openUrl(url);
    closeMenu();
  }

  return (
    <Menu
      {...{ anchorEl }}
      id="document-menu"
      keepMounted
      disableRestoreFocus={true}
      open={isMenuOpen}
      getContentAnchorEl={null}
      onClose={() => closeMenu()}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      PaperProps={Css.props(Css.br3.shadowHover.wPx(114).if(disableView).add("cursor", "not-allowed").$)}
    >
      <MenuItem onClick={handleViewClick} css={menuItemStyles} disabled={disableView}>
        View
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleDownloadClick} css={menuItemStyles}>
        Download
      </MenuItem>
    </Menu>
  );
}

const menuItemStyles = Css.f14.hPx(62).pl3.onHover.bgTransparentGray.$;
